exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ghost[data-v-5c5c9b9d] {\n  background-color: red;\n  transform:scaleY(0.05)!important;\n}\n.selected-row[data-v-5c5c9b9d] {\n  background-color: #e0e0e0;\n}\n.header-th[data-v-5c5c9b9d] {\n  border-bottom:1px solid;\n  font-size: 12px;\n  color: #00000099;\n  text-align: start;\n  padding: 0px 16px 0px;\n}\n", ""]);

// exports
